(function () {
  function markReady(root) {
    if (!('IntersectionObserver' in window)) {
      root.classList.add('is-ready');
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-ready');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -10% 0px' });

    observer.observe(root);
  }

  function bindActions(root) {
    var live = root.querySelector('[data-hero-live]');
    var actions = root.querySelectorAll('[data-hero-action]');

    actions.forEach(function (action) {
      action.addEventListener('click', function () {
        var monster = action.getAttribute('data-monster-name') || 'problem';
        var agent = action.getAttribute('data-agent-name') || 'Agent';

        actions.forEach(function (item) {
          item.setAttribute('aria-pressed', item === action ? 'true' : 'false');
        });

        if (live) live.textContent = agent + ' routed to ' + monster + '. Frame S remains ready.';
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-ds-hero]').forEach(function (root) {
      markReady(root);
      bindActions(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
